import feathersClient from '../../../../apiClient';
import moment from 'moment';
import { useQuery } from 'react-query';
import { ShiftDetailHistoryCard } from './ShiftDetailHistoryCard';
import {
  manshiftCountInCluster,
  ManShiftRecord,
  processShiftTimeline,
} from './shiftDetailHistoryUtils';
import Spinner from '@tymbe/ty-components/indicators/Spinner';
import { ShiftData } from '@tymbe/schema/shift.interface';

export const ShiftDetailHistory = ({ shiftId }: { shiftId: string }) => {
  const { data: shift, isLoading, isError } = useQuery(
    ['shiftTimeline', shiftId],
    async () =>
      feathersClient.service('shift').get(shiftId, {
        query: {
          $eager: '[manShift(withDeleted).[createdBy, deletedBy]]',
        },
      }),
    { enabled: !!shiftId, refetchOnWindowFocus: false }
  );

  const clustersByUserAndTime = processShiftTimeline(shift as ShiftData);

  const getAvatarInitials = (manShiftRecord: ManShiftRecord[]) =>
    manShiftRecord?.[0].data.person
      ? `${manShiftRecord?.[0].data.person?.first_name[0]}${manShiftRecord?.[0].data.person?.last_name[0]}`
      : 'T';

  const getTitle = (manShiftRecord: ManShiftRecord) =>
    manShiftRecord?.data.person
      ? `${manShiftRecord?.data.person?.first_name}
  ${manShiftRecord?.data.person?.last_name}`
      : 'Tymbe';

  if (isLoading) {
    return (
      <div className="flex justify-center">
        <Spinner
          className="size-5"
        />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex justify-center mt-5">
        Ups, něco se nepovedlo při získávání dat...
      </div>
    );
  }

  return (
    <div className="relative pl-8 overflow-y-auto">
      <div className="absolute left-4 top-0 h-full w-[1px] bg-secondary-transparent-10" />

      <div className="space-y-8">
        <ShiftDetailHistoryCard
          date={moment(shift?.start_time).format('DD.MM.YYYY')}
          time={moment(shift?.start_time).format('HH:mm')}
          title="System"
          badgeVariant="success"
          badgeText="Začátek směny"
          text={`Celkový počet ${
            shift?.manShift?.filter((row) => row.deleted_at === null).length
          }`}
          avatarInitials="S"
        />
        {clustersByUserAndTime
          .slice(1)
          .reverse()
          .map((el) => {
            const item = el[0];
            return (
              manshiftCountInCluster(el) !== 0 && (
                <ShiftDetailHistoryCard
                  date={moment(item?.time).format('DD.MM.YYYY')}
                  time={moment(item?.time).format('HH:mm')}
                  title={getTitle(item)}
                  text={`${manshiftCountInCluster(el) as number} Tymbeři`}
                  avatarInitials={getAvatarInitials(el)}
                />
              )
            );
          })}
        <ShiftDetailHistoryCard
          date={moment(clustersByUserAndTime[0]?.[0].time).format('DD.MM.YYYY')}
          time={moment(clustersByUserAndTime[0]?.[0].time).format('HH:mm')}
          title={getTitle(clustersByUserAndTime[0]?.[0])}
          badgeVariant="info"
          badgeText="Vznik objednávky"
          text={`${
            manshiftCountInCluster(clustersByUserAndTime[0]) as number
          } Tymbeři`}
          avatarInitials={getAvatarInitials(clustersByUserAndTime[0])}
        />
      </div>
    </div>
  );
};
